export default [{
    path: '/demo/image/',
    pathToRegexpOptions: { strict: true },
    component: () => import('views/ImageDemo')},{
    path: '/newsletter/',
    pathToRegexpOptions: { strict: true },
    component: () => import('views/Newsletter'),
    name: 'newsletter'},{
    path: '/newsletter/confirm/',
    pathToRegexpOptions: { strict: true },
    component: () => import('views/Newsletter'),
    name: 'newsletter-confirm'},{
    path: '/newsletter/cancel/',
    pathToRegexpOptions: { strict: true },
    component: () => import('views/Newsletter'),
    name: 'newsletter-cancel'},{
    path: '/privacy-policy/',
    pathToRegexpOptions: { strict: true },
    component: () => import('views/Page'),
    name: 'privacy-policy'},{
    path: '/confirm/',
    pathToRegexpOptions: { strict: true },
    component: () => import('views/ComingSoon')},{
    path: '/unsubscribe/',
    pathToRegexpOptions: { strict: true },
    component: () => import('views/ComingSoon')},{
    path: '/client/:client/:product/',
    pathToRegexpOptions: { strict: true },
    component: () => import('views/ClientProduct'),
    name: 'client-product'},{
    path: '/client/:client/',
    pathToRegexpOptions: { strict: true },
    component: () => import('views/Client'),
    name: 'client'},{
    path: '/smugmug/',
    pathToRegexpOptions: { strict: true },
    component: () => import('views/SmugMug'),
    name: 'smugmug'},{
    path: '/work/:project/:gallery/',
    pathToRegexpOptions: { strict: true },
    component: () => import('views/WorkGallery'),
    name: 'work-gallery'},{
    path: '/work/:project/',
    pathToRegexpOptions: { strict: true },
    component: () => import('views/WorkProject'),
    name: 'project'},{
    path: '/work/',
    pathToRegexpOptions: { strict: true },
    component: () => import('views/Work'),
    name: 'work'},{
    path: '/archive/',
    pathToRegexpOptions: { strict: true },
    component: () => import('views/Archive'),
    name: 'archive'},{
    path: '/archive/:section/:gallery/',
    pathToRegexpOptions: { strict: true },
    component: () => import('views/ArchiveGallery'),
    name: 'archive-gallery'},{
    path: '/news/:year/:month/:slug/',
    pathToRegexpOptions: { strict: true },
    component: () => import('views/NewsPost'),
    name: 'news-post'},{
    path: '/news/:year?/:month?/',
    pathToRegexpOptions: { strict: true },
    component: () => import('views/News'),
    name: 'news'},{
    path: '/storer-creek/:year/:month/:slug/',
    pathToRegexpOptions: { strict: true },
    component: () => import('views/BlogPost'),
    name: 'blog-post'},{
    path: '/storer-creek/:year?/',
    pathToRegexpOptions: { strict: true },
    component: () => import('views/Blog'),
    name: 'blog'},{
    path: '/about/',
    pathToRegexpOptions: { strict: true },
    component: () => import('views/About'),
    name: 'about'},{
    path: '/',
    pathToRegexpOptions: { strict: true },
    component: () => import('views/Home'),
    name: 'home'},{
    path: '/demo/tag/',
    pathToRegexpOptions: { strict: true },
    component: () => import('views/TagDemo')},{
    path: '/login/',
    pathToRegexpOptions: { strict: true },
    component: () => import('views/Login'),
    name: 'login'},{
    path: '/*',
    pathToRegexpOptions: { strict: true },
    component: () => import('views/NotFound'),
    name: 'not-found'}]


// WEBPACK FOOTER //
// ./app/.generated/routes.js